/**
 *  komponenta pro štítky pro produkty
 */
import React, { Fragment, useState } from "react";
import AddEditOrganiser from "./AddEditOrganiser";
import ModalNotification from "../../../GlobalComponents/ModalNotification";
import Notification from "../../../Library/notification";
import { useQuery, useMutation, useApolloClient } from "@apollo/client";
import { GET_ORGANISERS, DELETE_ORGANISERS } from "../Queries/organiser";
import Loading from "../../../GlobalComponents/Loading";
import Error from "../../../GlobalComponents/Error";
import edit from "../../../Public/Images/edit.svg";
import NoItems from "../../../GlobalComponents/NoItems";
import Helper from "../../../Library/helper";
import translate from "../../Translations/index";
import SearchInput from "../../General/Components/SearchInput";

const Organisers = (props) => {
    const client = useApolloClient();
    //zjistime jestli ma prihlaseny administrator spravna prava
    const helper = new Helper();
    helper.checkAdminRights({ ...props, client }, ["1", "2"]);

    const [searchQuery, setSearchQuery] = useState("");
    const [listVariables, setListVariables] = useState({
        filters: {
            offset: 0,
            limit: 50,
            searchQuery: "",
            sportID: 0,
            countryID: 0,
        },
        lang: translate.locale,
    });

    const [selectedOrganisers, setSelectedOrganisers] = useState([]);
    const [showDeleteNotifi, setShowDeleteNotifi] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [selectedOrganiserID, setSelectedOrganiserID] = useState("");
    const {
        loading,
        error: getError,
        data: organiserListData,
        fetchMore,
        refetch,
    } = useQuery(GET_ORGANISERS, {
        variables: listVariables,
        fetchPolicy: "cache-and-network",
        onError(err) {
            const helper = new Helper();
            let notify = new Notification();
            notify.setNotification(!!err.message ? err.message : err.toString(), "danger");
        },
    });

    const [deleteOrganiser, { data, loading: deleteLoading, error: deleteError }] = useMutation(DELETE_ORGANISERS, {
        update(cache, response) {
            let notify = new Notification();
            notify.setNotification(translate.t("SuccessFullyDeleted"));
            setShowDeleteNotifi(false);
            refetch({ filters: { ...listVariables.filters, limit: organiserListData.organisers.length } });
        },
        onError(err) {
            let notify = new Notification();
            notify.setNotification(!!err.message ? err.message : err.toString(), "danger");
        },
    });

    const openCloseModal = (open, organiserID) => {
        setSelectedOrganiserID(organiserID);
        setShowAdd(open);
    };

    /**
     * smazání štítků
     * @param {*} deleteOrganisers funkce, která posílá data na server
     * @param {*} organiserID ID organiseru
     */

    const initiateDeleteOrganiser = (e, organiserID) => {
        var checked = e.target.checked;
        var arr = [...selectedOrganisers];

        if (!checked) {
            for (let i in selectedOrganisers) {
                if (selectedOrganisers[i] == organiserID) {
                    arr.splice(i, 1);
                }
            }
        } else {
            arr = [organiserID, ...arr];
        }

        setSelectedOrganisers(arr);
    };

    const delOrganiser = (action) => {
        if (action) {
            let organiserIDs = selectedOrganisers.join(",");

            deleteOrganiser({
                variables: {
                    organiserIDs: organiserIDs,
                },
            });
        }
        setShowDeleteNotifi(false);
        //this.setState(INITIAL_STATE);
    };

    const showDelNotifi = () => {
        if (selectedOrganisers.length > 0) {
            setShowDeleteNotifi(true);
        } else {
            let notify = new Notification();
            notify.setNotification(translate.t("ItemNotSelected"), "danger");
        }
    };

    if (getError || deleteError) {
        var error = getError ? getError : deleteError;
        const helper = new Helper();
        error = "ERROR: " + helper.getApolloErrorText(error);
    }
    return (
        <div id="settings" className="whole-container">
            <div className="row">
                <div className="col-sm one">
                    <div className="card main">
                        <div className="card-header d-flex align-items-center">
                            {translate.t("OrganiserList")}
                            <button className="btn btn-primary btn-thiner ml-auto" onClick={() => openCloseModal(true, "")}>
                                {translate.t("Add")}
                            </button>
                            <button className="btn btn-danger btn-thiner ml-2" onClick={() => showDelNotifi()}>
                                {translate.t("DeleteSelected")}
                            </button>
                        </div>
                        <div className={`d-flex px-3 py-2 bg-light border-bottom align-items-center`}>
                            <div className="form-group mr-3">
                                <div className="text-nowrap fs12">{translate.t("Sport")}</div>
                                <select
                                    className="form-control form-control-sm"
                                    value={listVariables.filters.sportID}
                                    onChange={(e) => setListVariables({ ...listVariables, filters: { ...listVariables.filters, sportID: e.target.value } })}
                                >
                                    <option value={0}>-- {translate.t("Choose")} --</option>
                                    {organiserListData?.sports.map((item, index) => (
                                        <option key={index} value={item.sportID}>
                                            {item.title}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <div className="text-nowrap fs12">{translate.t("Country")}</div>
                                <select
                                    className="form-control form-control-sm"
                                    value={listVariables.filters.countryID}
                                    onChange={(e) => setListVariables({ ...listVariables, filters: { ...listVariables.filters, countryID: e.target.value } })}
                                >
                                    <option value={0}>-- {translate.t("Choose")} --</option>
                                    {organiserListData?.allCountries.map((item, index) => (
                                        <option key={index} value={item.countryID}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group ml-auto">
                                <div className="text-nowrap fs12">{translate.t("Search")}</div>
                                <SearchInput
                                    className={"form-control form-control-sm "}
                                    value={searchQuery}
                                    onChange={(text) => {
                                        setListVariables({ ...listVariables, filters: { ...listVariables.filters, searchQuery: text, offset: 0 } });
                                    }}
                                    textChanged={(text) => {
                                        setSearchQuery(text);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="card-body">
                            {!error ? (
                                <div>
                                    <div className="data-list">
                                        <div className="data-list-item header">
                                            <div className="data-list-item-content">
                                                <div>{translate.t("OrganiserTitle")}</div>
                                                <div>{translate.t("OrganiserCountry")}</div>
                                                <div>{translate.t("OrganiserSports")}</div>
                                                <div>{translate.t("OrganiserContactPersons")}</div>
                                                <div className="text-right">{translate.t("Options")}</div>
                                            </div>
                                        </div>
                                        <Fragment>
                                            {organiserListData?.organisers?.map((item, index) => {
                                                var checked = false;
                                                for (let i in selectedOrganisers) {
                                                    if (selectedOrganisers[i] == item.organiserID) checked = true;
                                                }

                                                return (
                                                    <div key={index} className="data-list-item-content">
                                                        <div>{item.name}</div>
                                                        <div>{item?.country?.name}</div>
                                                        <div>
                                                            {item?.sports?.map((item, index) => (
                                                                <div>{item.title}</div>
                                                            ))}
                                                        </div>
                                                        <div>
                                                            {item?.contactPersons?.map((item, index) => (
                                                                <div className="">
                                                                    {item.name}
                                                                    {(!!item.email || !!item.phone) && (
                                                                        <>
                                                                            <br />
                                                                            <span className="fs10">
                                                                                ({item.email}, {item.phone})
                                                                            </span>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className="text-right">
                                                            <img onClick={() => openCloseModal(true, item.organiserID)} className="edit-icon" src={edit} />
                                                            <input
                                                                className="delete-checked"
                                                                type="checkbox"
                                                                name="deleteOrganiser[]"
                                                                checked={checked}
                                                                onChange={(e) => initiateDeleteOrganiser(e, item.organiserID)}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </Fragment>
                                    </div>
                                    {!loading ? (
                                        <Fragment>
                                            {!loading && (
                                                <>
                                                    {!!organiserListData?.organisers?.length ? (
                                                        <>
                                                            {organiserListData.organisers.length < organiserListData.organisersCount && (
                                                                <div className="text-center p-5">
                                                                    <button
                                                                        className="btn btn-primary"
                                                                        onClick={() =>
                                                                            fetchMore({
                                                                                variables: {
                                                                                    ...listVariables,
                                                                                    filters: {
                                                                                        ...listVariables.filters,
                                                                                        offset: organiserListData.organisers.length,
                                                                                    },
                                                                                },
                                                                                updateQuery: (prev, { fetchMoreResult }) => {
                                                                                    if (!fetchMoreResult) return prev;
                                                                                    return Object.assign({}, prev, {
                                                                                        organisers: [...prev.organisers, ...fetchMoreResult.organisers],
                                                                                    });
                                                                                },
                                                                            })
                                                                        }
                                                                    >
                                                                        {" "}
                                                                        {translate.t("LoadMore")}{" "}
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <NoItems text={translate.t("NoItemsAddedYet")} />
                                                    )}
                                                </>
                                            )}
                                        </Fragment>
                                    ) : (
                                        <Loading />
                                    )}
                                </div>
                            ) : (
                                <Fragment>{error && <Error text={error} />}</Fragment>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {showAdd && (
                <AddEditOrganiser
                    openCloseModal={openCloseModal}
                    selectedOrganiserID={selectedOrganiserID}
                    listVariables={listVariables}
                    updated={() =>
                        refetch({
                            filters: {
                                ...listVariables.filters,
                                limit:
                                    listVariables.filters.limit > organiserListData.organisers.length
                                        ? listVariables.filters.limit
                                        : organiserListData.organisers.length,
                            },
                        })
                    }
                />
            )}
            {showDeleteNotifi && <ModalNotification yesNo={true} text={translate.t("RemoveItems?")} callback={delOrganiser} />}
        </div>
    );
};

export default Organisers;
